export default Object.freeze({
  'common.language.label': 'Language',
  'common.brand.name': 'Happy Pets',
  'common.download.action': 'Download',
  'common.store.appleprefix': 'Download on the',
  'common.store.applename': 'App Store',
  'common.store.googleprefix': 'GET IT ON',
  'common.store.googlename': 'Google Play',
  'seo.home.title': 'Happy Pets | AI Companion, Self-Discovery Tests & Pet Widgets',
  'seo.home.description': 'Meet an AI pet companion for daily reflection, personality and self-discovery tests, tarot, fortune, dream insights, interactive widgets, and co-raising with friends.',
  'seo.home.keywords': 'happy pets, AI companion, virtual pet app, pet widget, self discovery tests, personality test, mbti test, ai tarot',
  'seo.invite.title': 'Happy Pets Invite | Start Co-Raising a Virtual Pet',
  'seo.invite.description': 'Open your Happy Pets invitation to adopt or co-raise a virtual pet with friends on iPhone and Android.',
  'nav.skills.label': 'Skills',
  'nav.tests.label': 'Tests',
  'nav.guidance.label': 'AI Guidance',
  'nav.features.label': 'Features',
  'nav.experience.label': 'Experience',
  'nav.community.label': 'Community',
  'nav.news.label': 'News',
  'home.hero.titlelead': 'A Little Pet,',
  'home.hero.titleaccent': 'A Little Help Every Day',
  'home.hero.subtitle': 'Adopt a cozy virtual pet that lives on your screen, grows with you, and picks up helpful skills for daily assistance, fun, and lighthearted company.',
  'home.tools.eyebrow': 'Pet Skills',
  'home.tools.title': 'Everyday Skills Your Pet Can Help With',
  'home.tools.description': 'Turn your pet into a helpful daily companion with skills for reflection, food ideas, personality insights, and everyday decision-making.',
  'home.tools.action': 'Try now',
  'tool.tarot.tag': 'Reflection',
  'tool.tarot.title': 'Tarot',
  'tool.tarot.description': 'Let your pet pull a card, reflect on your question, and reveal a quick reading for the moment.',
  'tool.mbti.tag': 'Personality',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': 'Ask your pet to map your type, compare patterns, and uncover how you think and connect.',
  'tool.chef.tag': 'Kitchen',
  'tool.chef.title': 'Fridge Chef',
  'tool.chef.description': 'Turn what is already in your fridge into simple meal ideas with your pet as the clever little chef.',
  'tool.fortune.tag': 'Daily',
  'tool.fortune.title': 'Daily Fortune',
  'tool.fortune.description': 'Start the day with your pet reading a light forecast for mood, luck, and the little moments ahead.',
  'tool.calorie.tag': 'Health',
  'tool.calorie.title': 'Calorie Calculator',
  'tool.calorie.description': 'Let your pet help estimate calories, spot nutrition patterns, and make meal choices with less guesswork.',
  'tool.dream.tag': 'Dreams',
  'tool.dream.title': 'Dream Interpretation',
  'tool.dream.description': 'Have your pet decode symbols from last night and turn hazy dream fragments into something you can reflect on.',
  'home.assessments.eyebrow': 'Know Yourself Better',
  'home.assessments.title': 'Self-Discovery Tests With Results You Can Explore',
  'home.assessments.description': 'Take a structured personality, reasoning, career, or relationship assessment, then bring the result back into your conversations with your AI companion.',
  'home.assessments.action': 'Start test',
  'home.assessments.disclaimer': 'These assessments support self-exploration and entertainment. They do not replace medical diagnosis or professional advice.',
  'assessment.mbti.eyebrow': 'Personality',
  'assessment.mbti.title': 'MBTI Personality Test',
  'assessment.mbti.description': 'Explore your preferences, communication style, strengths, and growth patterns through a detailed personality assessment.',
  'assessment.mbti.meta': '108 questions',
  'assessment.sbti.eyebrow': 'Social Style',
  'assessment.sbti.title': 'SBTI Personality Test',
  'assessment.sbti.description': 'Discover how you show up around other people through five playful dimensions of emotion, action, and social energy.',
  'assessment.sbti.meta': '62 questions',
  'assessment.iq.eyebrow': 'Reasoning',
  'assessment.iq.title': 'IQ Reasoning Assessment',
  'assessment.iq.description': 'Work through nonverbal patterns and compare different areas of reasoning in a structured self-exploration experience.',
  'assessment.iq.meta': 'Visual reasoning',
  'assessment.holland.eyebrow': 'Career',
  'assessment.holland.title': 'Holland Career Interests',
  'assessment.holland.description': 'Identify the activities and work environments that may feel most natural to you across six interest themes.',
  'assessment.holland.meta': 'Career interests',
  'assessment.attachment.eyebrow': 'Relationships',
  'assessment.attachment.title': 'Attachment Style Test',
  'assessment.attachment.description': 'Reflect on closeness, trust, reassurance, and independence to better understand your relationship patterns.',
  'assessment.attachment.meta': 'Relationship insight',
  'home.guidance.eyebrow': 'A Gentle Daily Ritual',
  'home.guidance.title': 'AI Mystical Guidance, Grounded in Reflection',
  'home.guidance.description': 'Happy Pets uses tarot, daily fortune, and dream symbols as imaginative ways to slow down, name what you are feeling, and find a manageable next step. The goal is not certainty about the future, but a little more clarity and calm today.',
  'guidance.tarot.title': 'AI Tarot',
  'guidance.tarot.description': 'Choose cards around a question and use the reading as a gentle prompt for reflection, perspective, and your next small step.',
  'guidance.tarot.note': 'For reflection and entertainment',
  'guidance.fortune.title': 'Daily Fortune',
  'guidance.fortune.description': 'Begin the day with a light look at mood, energy, lucky details, and practical encouragement from your companion.',
  'guidance.fortune.note': 'Fresh guidance for each day',
  'guidance.dream.title': 'Dream Interpretation',
  'guidance.dream.description': 'Turn remembered images and feelings from a dream into themes you can explore without treating them as fixed predictions.',
  'guidance.dream.note': 'Symbols, feelings, and reflection',
  'home.features.eyebrow': 'Useful Skills, Daily Joy',
  'home.features.title': 'Why Your Pet Becomes So Helpful',
  'feature.raise.title': 'Raise Adorable Pets',
  'feature.raise.description': 'Feed, play, and watch them grow into companions that are cute, comforting, and surprisingly helpful.',
  'feature.hatch.title': 'Hatch New Skills',
  'feature.hatch.description': 'Collect eggs and discover unique pets that unlock different personalities and useful daily skills.',
  'feature.coraising.title': 'Co-Raise with Besties',
  'feature.coraising.description': 'Invite friends to care for pets together. Double the love, double the fun.',
  'feature.status.title': 'Daily Status',
  'feature.status.description': 'Track your daily status and share your feelings with your pet.',
  'feature.frequency.title': 'Daily Frequency',
  'feature.frequency.description': 'Create your own events and track their frequency, like water, running, and more.',
  'feature.cleaner.title': 'Photo Cleaner',
  'feature.cleaner.description': 'Keep your gallery tidy while playing. Fun and productive!',
  'feature.skills.title': 'AI Skill Room',
  'feature.skills.description': 'Unlock new looks and discover more ways your pet can help with reflection, planning, and everyday moments.',
  'feature.widget.title': 'Interactive Widget',
  'feature.widget.description': 'Keep your pet close with our interactive home screen widgets.',
  'home.steps.eyebrow': 'Getting Started',
  'home.steps.title': 'Hatch a Pet With Helpful Skills',
  'step.adopt.title': 'Adopt',
  'step.adopt.description': 'Choose your unique egg and start your journey with a pet companion of your own.',
  'step.grow.title': 'Grow',
  'step.grow.description': 'Feed, play, and interact daily to help your pet grow into a companion with more useful skills.',
  'step.together.title': 'Together',
  'step.together.description': 'Invite friends and let your pets share a world full of personality, support, and daily help.',
  'home.reviews.eyebrow': 'Community',
  'home.reviews.title': 'Loved for More Than Cuteness',
  'home.reviews.role': 'Pet Parent',
  'home.news.eyebrow': 'News & Stories',
  'home.news.title': 'Latest News',
  'home.news.description': 'Gentle ideas for life with your pet, self-discovery, and a little more wellbeing every day.',
  'home.news.readarticle': 'Read article',
  'home.news.exploreall': 'Explore all news',
  'review.one.text': 'My pet is adorable, but what surprised me most is how often I use its little daily skills.',
  'review.two.text': 'Co-raising a pet with my boyfriend has brought us joy, and the extra skills make it feel useful every day.',
  'review.three.text': 'The widgets are so interactive. I love having a cute companion on my home screen that also helps with everyday moments.',
  'home.footer.tagline': 'Bring joy and companionship to your home screen.',
  'home.footer.product': 'Product',
  'home.footer.support': 'Support',
  'home.footer.social': 'Social',
  'home.footer.skills': 'Pet Skills',
  'home.footer.features': 'Features',
  'home.footer.widgets': 'Widgets',
  'home.footer.help': 'Help Center',
  'home.footer.privacy': 'Privacy',
  'home.footer.harmonyprivacy': 'HarmonyOS Privacy',
  'home.footer.terms': 'Terms',
  'home.footer.copyright': '© 2024 Happy Pet. All rights reserved.',
  'home.image.logoalt': 'Happy Pets logo',
  'home.image.screenalt': 'Happy Pets app screen',
  'home.image.enlargedalt': 'Enlarged Happy Pets screen',
  'home.image.close': 'Close image',
  'invite.headline': "Your friends are inviting you to get a pet, so let's play with it!",
  'invite.description': 'Accept the invitation and the egg hatches instantly. Add your pet to your home screen.',
  'invite.download': 'Download',
  'invite.loadingalt': 'Loading Happy Pets',
  'invite.screensalt': 'Happy Pets app screenshots'
})
